import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ScrollerModule } from "primeng/scroller";
import { TableModule } from "primeng/table";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { CheckboxModule } from "primeng/checkbox";

@Component({
  selector: "jni-invoice-emails",
  templateUrl: "./invoice-emails.component.html",
  styleUrls: ["./invoice-emails.component.scss"],
  imports: [
    TableModule,
    ScrollerModule,
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
  ],
})
export class InvoiceEmailsComponent {
  @Input() invoiceListing!: {
    id: number;
    name: string;
    purpose: string;
    email: string;
  }[];
  @Input() parent!: FormGroup;
  @Output() newLine = new EventEmitter<boolean>();
  @Output() removeEmail = new EventEmitter<FormGroup[]>();

  emailSelected!: FormGroup[];

  get invoicedEmails() {
    return (this.parent.get("invoicedEmails") as FormArray).controls;
  }

  onRemoveEmail() {
    if (this.emailSelected) {
      this.removeEmail.emit(this.emailSelected);
      this.emailSelected = [];
    }
  }
}
